module.exports = __webpack_public_path__ + "static/media/r5d4.018ab4f0.jpg";